import PropTypes from 'prop-types';
import '@fec/frontend-aron/elements/media/BasicCaption/BasicCaption.scss';

const ImageCaption = ({ image }) => {
  const { title, legend, source, sourceLink } = image;

  return (
    <div className="basic-caption">
      <div className="basic-caption__title" data-app-image-title>
        {title}
      </div>
      <div className="basic-caption__legend" data-app-image-description>
        {legend}
      </div>
      {source && (
        <>
          {sourceLink ? (
            <a
              href={sourceLink}
              className="basic-caption__image-source-link"
              rel="nofollow noreferrer"
              target="_blank"
              data-app-image-source="">
              {source}
            </a>
          ) : (
            <div
              className="basic-caption__image-source"
              data-app-image-source="">
              {source}
            </div>
          )}
        </>
      )}
    </div>
  );
};

ImageCaption.propTypes = {
  image: PropTypes.object.isRequired,
};

export default ImageCaption;
